// Seed the commerce channel (sent as X-Channel) when not already set.
// The backend's /public/* basket & product endpoints require a channel Tag and
// return 500 without one. This app has no channel switcher, so we default it from
// runtimeConfig (NUXT_PUBLIC_DEFAULT_CHANNEL). Runs on server + client so SSR fetches
// carry the header too. setChannel() toggles, so we assign cookie/state directly.
export default defineNuxtPlugin(() => {
  const {
    public: { defaultChannel },
  } = useRuntimeConfig()
  if (!defaultChannel) return

  const { channel } = useChannel()
  if (channel.value) return

  const cookie = useCookie<string | null>('channel', { sameSite: true, secure: true })
  cookie.value = String(defaultChannel)
  channel.value = String(defaultChannel)
})
